// Placeholder for Crashlytics module
export function recordError(error: Error): void {
  console.error("Crashlytics.recordError:", error);
}

export function log(message: string): void {
  console.log("Crashlytics.log:", message);
}

export const crashlyticsLog = log;
export const crashlyticsRecordError = recordError;
